import { Component, EventEmitter, Inject } from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl } from "@angular/forms";
import { Beneficiary } from "src/app/ui/models/domains/pbm/Beneficiary/beneficiary";
import { CardUnblockDTO } from "src/app/ui/models/domains/pbm/Beneficiary/dto/card-unblock-dto";
import { Dependent } from "src/app/ui/models/domains/pbm/Beneficiary/dependent";
import { LoadingService } from "src/app/ui/services/loading.service";
import { BeneficiaryService } from "src/app/ui/services/pbm/beneficiary.service";
import { Toast } from "../../../../toast/toast";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  templateUrl: "./card-unblock-dialog.component.html",
  styleUrls: ["./card-unblock-dialog.component.scss"],
})
export class CardUnblockDialogComponent {
  unblockCardNumberEvent: EventEmitter<Beneficiary | Dependent> = new EventEmitter();
  includeDependetsFormControl = new UntypedFormControl(false);

  constructor(
    public dialogRef: MatDialogRef<CardUnblockDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Beneficiary | Dependent,
    public beneficiaryService: BeneficiaryService,
    public formBuilder: UntypedFormBuilder,
    private loadingService: LoadingService,
    private toast: Toast,
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }

  async unblockBeneficiaryCard(): Promise<void> {
    const loadingRef = this.loadingService.beginLoading();

    try {
      const cardUnblockDTO = this.buildCardUnblockDTO();
      await this.beneficiaryService.unblockBeneficiaryCard(cardUnblockDTO);
      this.toast.showSuccessToast("Cartão desbloqueado com sucesso.");
      this.unblockCardNumberEvent.emit(this.data);
      this.closeDialog();
    } catch (err) {
      this.toast.showWarningToast("Erro ao desbloquear cartão.");
    } finally {
      loadingRef.closeLoading();
    }
  }

  private buildCardUnblockDTO(): CardUnblockDTO {
    const beneficiaryKey = this.data.getBeneficiaryKey();
    const includeDependents = this.includeDependetsFormControl.value;

    return new CardUnblockDTO(beneficiaryKey, includeDependents);
  }

  public isBeneficiary(): boolean {
    return this.data instanceof Beneficiary;
  }

  public getName(): string {
    return this.data.getName();
  }

  public getCardNumber(): string {
    return this.data.getCard().getCardNumber();
  }
}
